import { connect } from 'react-redux';
import React from 'react';
import * as valid from 'utils/validate';
import { renderKBSelect, withReduxFormFieldProps } from 'components/formAdapters/reduxFormAdapters';
import { Field, reduxForm } from 'redux-form';
import { KBFormError,
KBButton } from
'components';
import { AREA_RENTING_TYPE } from 'app/constants';
import * as selectors from 'app/selectors';

var SpaceSettingAreaRentingTypeForm = class extends React.Component {constructor(props) {super(props);this.updateSpace = this.updateSpace.bind(this);}updateSpace(

  model) {
    const { updateCurrentSpace } = this.props;
    updateCurrentSpace(
    {
      settings: JSON.stringify({
        general_settings: model }) },


    {
      key: 'general_settings' });


  }render()
  {
    const {
      fields: { area_renting_type },
      error,
      submitting,
      handleSubmit,
      updateCurrentSpace } =
    this.props;
    return (
      <form onSubmit={handleSubmit(this.updateSpace)}>
        <KBFormError err={this.props.error} />
        <div className="kb-form-container" style={{ padding: 0 }}>
          <div className="kb-row">
            <Field name="area_renting_type" component={renderKBSelect}
            className="kb-form-group kb-form-c18 kb-form-alone"
            title="租赁方式"

            arrayData={AREA_RENTING_TYPE} />

          </div>
          <div className="kb-row m-top">
            <KBButton
            className="certain-btn"
            type="submit"
            submitting={submitting}>

              保存
            </KBButton>
          </div>
        </div>
      </form>);

  }};


function mapStateToProps(state, props) {
  const setting = props.setting || {};
  const settings = setting.settings || {};
  let setting_value = settings.area_renting_type || 'by_area';

  return {
    initialValues: {
      area_renting_type: setting_value } };


}

const LEGACY_FORM_FIELDS = [
  "area_renting_type"
];

const formConfig = {
  form: 'SpaceSettingAreaRentingTypeForm',
  touchOnBlur: false };


export default connect(mapStateToProps)(reduxForm(formConfig)(withReduxFormFieldProps('SpaceSettingAreaRentingTypeForm', LEGACY_FORM_FIELDS)(SpaceSettingAreaRentingTypeForm)));
